import { styled } from "styled-components";

import fondo1 from "../../../assets/img/fondo-1.png";
import fondo2 from "../../../assets/img/fondo-2.png";
import fondo3 from "../../../assets/img/fondo-3.png";
import trazo from "../../../assets/img/home.svg";

export const ContainerHistory = styled.div`
  overflow-y: auto;  // Permite el desplazamiento vertical
  section {
    height: 100%;
    width: 100%;
    top: 0;
    position: relative;
    visibility: inherit;
  }
  section .outer,
  section .inner {
    width: 100%;
    height: 100vh;
    overflow-y: hidden;
  }
  section .bg {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    height: 100vh;
    width: 100%;
    top: 0;
    background-size: cover;
    background-position: center;
  }
  section .bg h2 {
    z-index: 2;
  }
  section .bg .clip-text {
    overflow: hidden;
  }

  h2 {
    color: black;
    font-size: 50px;
    line-height: 62px;
    text-align: center;
    padding: 0 30px;
    @media (min-width: 1024px) {
      font-size: 150px;
      line-height: 160px;
  }
  }

  p {
    color: black;
    max-width: 1000px;
    width: 100%;
    margin-top: 20px;
    font-size: 20px;
    line-height: 25px;
    text-align: center;
    padding: 0 30px;
    @media (min-width: 1024px) {
      margin-top: 80px;
      font-size: 40px;
    line-height: 45px;
  }
  }

  .zero .bg {
    background-image:
      url(${trazo});
      background-color: white;
  }


  .first .bg {
    background-image:
      url(${fondo1});
      background-color: white;
  }

  .second .bg {
    background-color: #59CBE8;
  }

  .second h2, .second p {
    color: white
  }

  .third .bg {
    background-image:
      url(${fondo3});
      background-color: white;
  }

  .fourth .bg {
    background-color:  #9063CD;
  }

  .fourth h2, .fourth p {
    color: white
  }

  .fifth .bg {
    background-image: 
      url(${fondo2});
    background-position: 50% 45%;
    background-color: white;
  }

  .six .bg {
    background-color: white;
  }

  .seven .bg {
    background-color: white;
  }

  .six section .outer,
  .six section .inner {
    width: 100%;
    height: auto;
    overflow-y: hidden;
  }

  .seven section .outer,
  .seven section .inner {
    width: 100%;
    height: auto;
    overflow-y: hidden;
  }

  h2 * {
    will-change: transform;
  }
`;
